module.exports = __webpack_public_path__ + "img/32.107f5c06.jpg";